export class Incident {
    constructor(
        public id?: string | null,
        public name?: string | null,
        public status?: string | null,
        public auto_transition_to_maintenance_state?: boolean | null,
        public auto_transition_to_operational_state?: boolean | null,
        public auto_transition_deliver_notifications_at_start?: boolean | null,
        public auto_transition_deliver_notifications_at_end?: boolean | null,
        public metadata?: {} | null,
        public deliver_notifications?: boolean | null,
        public body?: string | null,
        public components?: {},
        public component_ids?: string[] | null,
        public incident_updates?: any[] | null
    ) {}
}